<template>
  <div class="step">
    <div class="step-con">
      <div class="step-icon">
        <i :class="['iconfont', icon]"></i>
      </div>
      <div class="step-name">
        <slot>{{name}}</slot>
      </div>
      <div class="step-num">
        <span>{{step}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ep-step',
  props: {
    icon: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: '步骤名称'
    },
    step: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  }
} 
</script>

<style scoped>
.step {
  display: inline-block;
  /* height: 80px; */
  flex: 1;
  cursor: pointer;
}

.step:not(:last-child) {
  margin-right: 10px;
}

.step:hover .step-icon {
  color: #20a0ff;
}

.step:hover .step-num span {
  background-color: #20a0ff;
  box-shadow: 0 0 10px 5px rgba(32, 160, 255, .5);
}


/* .step:hover .step-name {
    font-size: 15px;
  } */

.step .step-con {
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 10px;
  transition: all .3s ease-in-out;
}
.step .active {
	height: 60px;
}
.step-con .step-icon {
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
  text-align: center;
  line-height: 30px;
  transition: all .3s ease-in-out;
}

.step-con .step-icon i {
  font-size: 30px;
}

.step-con .step-name {
  width: 100%;
  height: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  color: #373d41;
  transition: all .3s ease-in-out;
}

.step-con .step-num {
  height: 40px;
  width: 100%;
  position: absolute;
  bottom: -40px;
  text-align: center;
  z-index: 1;
}

.step-con .step-num span {
  transition: all .3s ease-in-out;
  display: block;
  margin: 10px calc((100% - 20px) / 2);
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: #373d41;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// Step.vue?cbef3248